import { Municipio, Uf } from './uniao';

export class Endereco {
  id: string;
  apelido: string;
  cep: string;
  logradouro: string;
  numero: string;
  complemento: string;
  bairro: string;
  cidade: string;
  uf: string;
  pontoReferencia: string;
  latitude: number;
  longitude: number;
  // Entidade IBGE escolhida, com a UF dentro. `cidade` e `uf` continuam sendo as strings
  // que a tela mostra e a validacao cobra; isto e o que o pedido precisa mandar.
  municipio: Municipio;
}

// O `pedidoEntrega` passou a exigir `municipio` e `uf` como OBJETOS: mandar string faz o
// Mongoose recusar com "Cast to Embedded failed ... ObjectExpectedError".
//
// Endereco salvo antes disso nao tem a entidade, entao cai no objeto minimo montado a
// partir das strings - o backend aceita qualquer objeto, so nao aceita texto. Assim
// ninguem precisa recadastrar o endereco.
export function enderecoUfEntidade(endereco: Endereco): Uf {
  return endereco?.municipio?.uf || { codigo: '', nome: endereco?.uf || '', sigla: endereco?.uf || '' };
}

export function enderecoMunicipioEntidade(endereco: Endereco): Municipio {
  return endereco?.municipio
    || { codigo: '', nome: endereco?.cidade || '', uf: enderecoUfEntidade(endereco) };
}

export function cepDigitos(cep: string): string {
  return (cep || '').replace(/\D/g, '');
}

// O hifen so entra a partir do sexto digito: antes disso ele reaparece sozinho quando o
// usuario apaga, e o cursor trava.
export function cepFormata(cep: string): string {
  const digitos = cepDigitos(cep).slice(0, 8);
  if (digitos.length <= 5) {
    return digitos;
  }
  return `${digitos.slice(0, 5)}-${digitos.slice(5)}`;
}

export function cepValido(cep: string): boolean {
  return cepDigitos(cep).length === 8;
}
